export default {
    verticalTabsItemText: 'vertical-tabs-item-text',
    verticalTabsItemPrefixIcon: 'vertical-tabs-item-prefix-icon',
    verticalTabsItemSuffixIcon: 'vertical-tabs-item-suffix-icon',
};
//# sourceMappingURL=dataHooks.js.map